import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 69A854BB-0CC9-4E1B-855E-FD26E9E6D119
 * name home-city-outline
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-city-outline.svg
 * tags
 * - Home Automation 
 * - Places 
 */
export const HomeCityOutlineIcon = createSvgIcon(<><path d="M10,2V4.26L12,5.59V4H22V19H17V21H24V2H10M7.5,5L0,10V21H15V10L7.5,5M14,6V6.93L15.61,8H16V6H14M18,6V8H20V6H18M7.5,7.5L13,11V19H10V13H5V19H2V11L7.5,7.5M18,10V12H20V10H18M18,14V16H20V14H18Z" /></>, 'HomeCityOutlineIcon');
export default HomeCityOutlineIcon